module.exports = __webpack_public_path__ + "img/close.35a6ccb5.svg";